"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavbarGroup = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var React = tslib_1.__importStar(require("react"));
var common_1 = require("../../common");
var errors_1 = require("../../common/errors");
var props_1 = require("../../common/props");
var useValidateProps_1 = require("../../hooks/useValidateProps");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var NavbarGroup = function (_a) {
    var _b = _a.align, align = _b === void 0 ? common_1.Alignment.START : _b, children = _a.children, className = _a.className, htmlProps = tslib_1.__rest(_a, ["align", "children", "className"]);
    var classes = (0, classnames_1.default)(common_1.Classes.NAVBAR_GROUP, common_1.Classes.alignmentClass(align), className);
    (0, useValidateProps_1.useValidateProps)(function () {
        if (align === common_1.Alignment.CENTER) {
            console.warn(errors_1.NAVBAR_GROUP_ALIGN_CENTER);
        }
    }, [align]);
    return (React.createElement("div", tslib_1.__assign({ className: classes }, htmlProps), children));
};
exports.NavbarGroup = NavbarGroup;
exports.NavbarGroup.displayName = "".concat(props_1.DISPLAYNAME_PREFIX, ".NavbarGroup");
//# sourceMappingURL=navbarGroup.js.map